export default {
  root: {
    fontSize: 50,
    zIndex: 1,
    display: 'flex',
    color: '#CFCECE',
    '&.Mui-active': {
      color: '#709933',
    },
    '&.Mui-completed': {
      color: '#709933',
    },
  },
};
